import { computed, observable, reaction } from 'mobx';
import { createRef } from 'react';
import useMount from '@src/utils/hooks/use-mount';
import { noop } from '@src/utils/common-util';
import { px2rem2 } from '@src/utils/rem-util';
import _debounce from 'lodash.debounce';

class TabMenuStore {
  @observable activeIndex = 0;
  @observable x = 0;
  calcInfo = null;

  @computed
  get activeTab() {
    return this.tabList[this.activeIndex];
  }

  onTabChange = noop;

  constructor(props) {
    Object.assign(this, props);
  }

  // { tab_title: '最新', tab_key: 'new' }[]
  @observable tabList = [];

  handleTabChange = (index, tabItem) => {
    this.activeIndex = index;
    this.calcX(index);
    this.onTabChange?.(index, tabItem);
  };

  calcX = index => {
    const { tabInnerWidth, rectInfoList } = this.getCalcInfo();
    if (rectInfoList.length === 0) {
      return;
    }
    const { activeWidth } = rectInfoList[index];
    const gap =
      (tabInnerWidth -
        rectInfoList.reduce((prev, cur, index) => {
          if (index === this.activeIndex) {
            return prev + cur.activeWidth;
          }
          return prev + cur.width;
        }, 0)) /
      (rectInfoList.length - 1);
    this.x =
      gap * index +
      rectInfoList.slice(0, index).reduce((prev, cur) => {
        return prev + cur.width;
      }, 0) +
      activeWidth / 2;
  };

  getTextWidth = (text, fontSize) => {
    // 创建一个临时的 span 元素
    const span = document.createElement('span');
    // 设置字体属性
    span.style.fontSize = `${fontSize}rem`;
    // span.style.fontFamily = 'Arial'; // 可以根据需要更改字体
    span.style.position = 'absolute'; // 不影响文档流
    span.style.visibility = 'hidden'; // 隐藏元素
    span.style.whiteSpace = 'nowrap'; // 防止换行
    // 将文本添加到 span 中
    span.textContent = text;
    // 将 span 添加到文档中
    this.tabInnerRef.current.appendChild(span);
    // 获取宽度
    const width = span.offsetWidth;
    // 从文档中移除 span
    this.tabInnerRef.current.removeChild(span);
    return width; // 返回测量的宽度
  };

  getCalcInfo = () => {
    const tabInner = this.tabInnerRef.current;
    const tabInnerWidth = tabInner.offsetWidth;
    const tabItemRectInfo = this.tabItemListRef.current.map((el, index) => {
      const { tab_title } = this.tabList[index];
      return { width: this.getTextWidth(tab_title, px2rem2(30)), activeWidth: this.getTextWidth(tab_title, px2rem2(37)) };
    });
    return { tabInnerWidth, rectInfoList: tabItemRectInfo };
  };

  use() {
    this.tabInnerRef = createRef();
    this.tabItemListRef = createRef([]);
    this.tabItemListRef.current = [];

    useMount(() => {
      reaction(
        () => this.tabList.length,
        () => {
          setTimeout(() => {
            this.calcX(this.activeIndex);
          });
        }
      );

      const resizeHandler = _debounce(() => {
        setTimeout(() => {
          this.calcX(this.activeIndex);
        }, 500);
      }, 300);
      window.addEventListener('resize', resizeHandler);

      return () => {
        window.removeEventListener('resize', resizeHandler);
      };
    });
  }
}

export default TabMenuStore;
